import React, { useState } from 'react';
import ProductionCalendar from '../ProductionCalendar';
import './KnowledgeBase.css';

const KnowledgeBase = () => {
  const [activeCategory, setActiveCategory] = useState('news');
  const [searchTerm, setSearchTerm] = useState('');

  const knowledgeData = {
    news: [
      {
        id: 1,
        title: "ВС РФ: единственное ипотечное жилье не гарантирует утверждение мирового соглашения с банком",
        number: "Обзор №318, 23-29.04.2026",
        description: "Верховный Суд поддержал отказ в утверждении локального плана реструктуризации долга, поскольку условия соглашения существенно ухудшали положение залогового кредитора.",
        category: "Судебная практика",
        url: "https://www.pgplaw.ru/analytics-and-brochures/bankruptcy-must-read/bankruptcy-digest-29-04-26/",
        date: "2026-04-29",
        tags: ["банкротство граждан", "ипотека", "мировое соглашение", "ВС РФ"]
      },
      {
        id: 2,
        title: "ПСБ выставил конфискованный «Русмаркет» на онлайн-аукцион за 238,8 млн рублей",
        number: "Коммерсантъ, 17.04.2026",
        description: "Прием заявок завершался 23 апреля 2026 года, торги назначались в онлайн-формате; шаг аукциона - 1%, задаток - 20% стартовой цены.",
        category: "Торги и реализация активов",
        url: "https://www.kommersant.ru/doc/8603673",
        date: "2026-04-17",
        tags: ["торги", "аукцион", "Росимущество", "конфискованное имущество"]
      },
      {
        id: 3,
        title: "Опубликован обзор ключевых изменений законодательства о банкротстве в 2026 году",
        number: "КонсультантПлюс, актуально на 14.04.2026",
        description: "Среди важных изменений - новый порядок распределения выручки от продажи единственного ипотечного жилья и уточнения по реестру СРО в сфере банкротства.",
        category: "Законодательство",
        url: "https://www.consultant.ru/document/cons_doc_LAW_524072/",
        date: "2026-04-14",
        tags: ["законодательство", "банкротство", "ипотека", "СРО"]
      },
      {
        id: 4,
        title: "В Госдуму внесен законопроект о добанкротной санации и реструктуризации долгов юрлиц",
        number: "Проект №1188799-8, 26.03.2026",
        description: "Инициатива предлагает механизмы добанкротной санации, новую процедуру реструктуризации долгов компаний и изменения в саморегулировании сферы банкротства.",
        category: "Законопроекты",
        url: "https://www.pnp.ru/economics/v-gosdumu-vnesli-zakonoproekt-o-novom-mekhanizme-resheniya-problem-bankrotstva.html",
        date: "2026-03-26",
        tags: ["реформа банкротства", "санация", "реструктуризация", "Госдума"]
      },
      {
        id: 5,
        title: "Федресурс опубликовал статистический бюллетень по банкротствам за 2025 год",
        number: "NOVATOR / Федресурс, 13.03.2026",
        description: "В обзоре отмечены снижение числа корпоративных банкротств, рост процедур граждан почти до 606 тыс. и увеличение роли субсидиарной ответственности.",
        category: "Статистика банкротств",
        url: "https://novatorlaw.com/news/fedresurs-opublikoval-statisticheskiy-byulleten-po-bankrotstvam-v-rossii-za-2025-god/",
        date: "2026-03-13",
        tags: ["Федресурс", "статистика", "банкротство граждан", "субсидиарная ответственность"]
      },
      {
        id: 6,
        title: "Опубликован анализ торгов по банкротству и активности ЭТП за 4 квартал 2025 года",
        number: "Федресурс / БСР-Консалтинг, 05.03.2026",
        description: "По итогам 2025 года количество лотов выросло на 12%, объем реализации имущества увеличился на 6%, а публичное предложение стало поддерживать рынок при снижении среднего чека.",
        category: "Аналитика торгов",
        url: "https://myseldon.com/ru/news/index/342689165",
        date: "2026-03-05",
        tags: ["торги по банкротству", "ЭТП", "Федресурс", "публичное предложение"]
      },
      {
        id: 7,
        title: "Федресурс представил рэнкинги ЭТП, осуществляющих торги в банкротстве, за 4 квартал 2025 года",
        number: "Центр Реализации, 12.02.2026",
        description: "Опубликованы агрегированные сведения электронных торговых площадок, включая данные за 4 квартал 2025 года и исторические ряды с 2015 года.",
        category: "Рэнкинги ЭТП",
        url: "https://arrest.centerr.ru/public/news/view/274/",
        date: "2026-02-12",
        tags: ["ЭТП", "рэнкинг", "торги", "Федресурс"]
      }
    ],
    legislation: [
      {
        id: 101,
        title: "Федеральный закон «О несостоятельности (банкротстве)»",
        number: "127-ФЗ, ред. 2026 года",
        description: "Базовый акт, регулирующий процедуры банкротства граждан и организаций, продажу имущества должников и полномочия арбитражных управляющих.",
        category: "Федеральное законодательство",
        url: "http://www.consultant.ru/document/cons_doc_LAW_39331/",
        date: "2002-10-26",
        tags: ["банкротство", "торги", "должник", "арбитражный управляющий"]
      },
      {
        id: 102,
        title: "Федеральный закон №62-ФЗ о распределении выручки от продажи единственного ипотечного жилья",
        number: "62-ФЗ от 23.03.2026",
        description: "Закон установил специальный порядок распределения средств при продаже в банкротстве единственного жилья, обремененного ипотекой.",
        category: "Изменения 2026 года",
        url: "https://www.consultant.ru/document/cons_doc_LAW_529526/",
        date: "2026-03-23",
        tags: ["банкротство граждан", "ипотека", "единственное жилье"]
      },
      {
        id: 103,
        title: "Приказ Минэкономразвития №495 о порядке электронных торгов в банкротстве",
        number: "495 от 23.07.2015, ред. от 29.10.2025",
        description: "Порядок проведения электронных торгов по продаже имущества или предприятия должников и требования к операторам электронных площадок.",
        category: "Подзаконные акты",
        url: "https://www.consultant.ru/document/cons_doc_LAW_194513/",
        date: "2015-07-23",
        tags: ["торги", "ЭТП", "публичное предложение", "задаток"]
      }
    ],
    practice: [
      {
        id: 201,
        title: "ВС РФ по делу о локальном плане реструктуризации ипотечного долга",
        number: "305-ЭС26-470 (2) от 17.04.2026",
        description: "Суд указал, что план погашения долга без согласия залогового кредитора возможен только при доказанном отсутствии ухудшения положения такого кредитора.",
        category: "Верховный Суд РФ",
        url: "https://www.pgplaw.ru/analytics-and-brochures/bankruptcy-must-read/bankruptcy-digest-29-04-26/",
        date: "2026-04-17",
        tags: ["ВС РФ", "ипотека", "залоговый кредитор", "реструктуризация"]
      },
      {
        id: 202,
        title: "Постановление Пленума ВАС РФ №35",
        number: "35 от 23.07.2009",
        description: "О применении арбитражными судами законодательства о банкротстве",
        category: "Высший Арбитражный Суд РФ",
        url: "http://www.consultant.ru/document/cons_doc_LAW_90095/",
        date: "2009-07-23",
        tags: ["банкротство", "судебная практика", "применение"]
      },
      {
        id: 203,
        title: "Обзор «Банкротство: взгляд эксперта» за 23-29 апреля 2026 года",
        number: "Обзор №318 от 29.04.2026",
        description: "Подборка свежих позиций по залогу, мировым соглашениям, субсидиарной ответственности, убыткам и оспариванию сделок.",
        category: "Обзоры практики",
        url: "https://www.pgplaw.ru/analytics-and-brochures/bankruptcy-must-read/bankruptcy-digest-29-04-26/",
        date: "2026-04-29",
        tags: ["судебная практика", "залог", "субсидиарная ответственность"]
      }
    ],
    analytics: [
      {
        id: 301,
        title: "Статистический бюллетень Федресурса по банкротствам за 2025 год",
        number: "13.03.2026",
        description: "Ключевые итоги года: меньше корпоративных банкротств, рост банкротств граждан, длительные процедуры и высокая доля удовлетворения заявлений о субсидиарной ответственности.",
        category: "Статистика банкротств",
        url: "https://novatorlaw.com/news/fedresurs-opublikoval-statisticheskiy-byulleten-po-bankrotstvam-v-rossii-za-2025-god/",
        date: "2026-03-13",
        tags: ["Федресурс", "статистика", "банкротство компаний", "банкротство граждан"]
      },
      {
        id: 302,
        title: "Анализ торгов по банкротству и активности электронных торговых площадок за 4 квартал 2025 года",
        number: "05.03.2026",
        description: "Материал по данным Федресурса показывает рост количества лотов за 2025 год и изменение структуры успешных торгов в пользу публичного предложения.",
        category: "Аналитика торгов",
        url: "https://myseldon.com/ru/news/index/342689165",
        date: "2026-03-05",
        tags: ["торги", "ЭТП", "публичное предложение", "Федресурс"]
      },
      {
        id: 303,
        title: "Рэнкинги ЭТП по торгам в банкротстве за 4 квартал 2025 года",
        number: "12.02.2026",
        description: "Сводные данные электронных торговых площадок по количеству лотов, участникам и результатам торгов; доступны квартальные и исторические показатели.",
        category: "Рэнкинги ЭТП",
        url: "https://arrest.centerr.ru/public/news/view/274/",
        date: "2026-02-12",
        tags: ["ЭТП", "рэнкинг", "торги по банкротству"]
      }
    ]
  };

  const categories = [
    { key: 'news', label: 'Новости', icon: '📰' },
    { key: 'legislation', label: 'Законодательство', icon: '📜' },
    { key: 'practice', label: 'Судебная практика', icon: '⚖️' },
    { key: 'analytics', label: 'Аналитика и статистика', icon: '📊'},
    { key: 'calendar', label: 'Производственный календарь', icon: '📅'}
  ];

  const filteredData = knowledgeData[activeCategory]?.filter(item =>
    item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()))
  ) || [];

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="knowledge-base">
      <div className="knowledge-header">
        <div className="header-content">
          <h1>📚 База знаний</h1>
          <p>Новости, законодательство, судебная практика и аналитика по банкротству и торгам</p>
        </div>
        
        <div className="search-container">
          <input
            type="text"
            placeholder="Поиск по базе знаний..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <span className="search-icon">🔍</span>
        </div>
      </div>

      <div className="knowledge-content">
        <div className="categories-sidebar">
          <h3>Разделы</h3>
          <ul className="categories-list">
            {categories.map(category => (
              <li key={category.key}>
                <button
                  type="button"
                  className={`category-btn ${activeCategory === category.key ? 'active' : ''}`}
                  onClick={() => setActiveCategory(category.key)}
                >
                  <span className="category-icon">{category.icon}</span>
                  <span className="category-label">{category.label}</span>
                  <span className="category-count">
                    {category.key === 'calendar' ? '' : `(${knowledgeData[category.key]?.length || 0})`}
                  </span>
                </button>
              </li>
            ))}
          </ul>

          <div className="sidebar-stats">
            <h4>Статистика</h4>
            <div className="stat-item">
              <span className="stat-label">Всего материалов:</span>
              <span className="stat-value">
                {Object.values(knowledgeData).reduce((acc, arr) => acc + arr.length, 0)}
              </span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Последнее обновление:</span>
              <span className="stat-value">30.04.2026</span>
            </div>
          </div>
        </div>

        <div className="materials-content">
          <div className="content-header">
            <h2>
              {categories.find(cat => cat.key === activeCategory)?.icon}
              {categories.find(cat => cat.key === activeCategory)?.label}
            </h2>
            {activeCategory !== 'calendar' && (
              <div className="results-count">
                Найдено материалов: {filteredData.length}
              </div>
            )}
          </div>

          {activeCategory === 'calendar' ? (
            <ProductionCalendar />
          ) : (
            <div className="materials-list">
              {filteredData.length > 0 ? (
                filteredData.map(item => (
                  <div key={item.id} className="material-card">
                    <div className="material-header">
                      <h3 className="material-title">{item.title}</h3>
                      <div className="material-meta">
                        <span className="material-number">{item.number}</span>
                        <span className="material-date">{formatDate(item.date)}</span>
                      </div>
                    </div>
                    
                    <div className="material-body">
                      <p className="material-description">{item.description}</p>
                      <div className="material-category">
                        <span className="category-badge">{item.category}</span>
                      </div>
                    </div>
                    
                    <div className="material-footer">
                      <div className="material-tags">
                        {item.tags.map(tag => (
                          <span key={tag} className="tag">{tag}</span>
                        ))}
                      </div>
                      <div className="material-actions">
                        {item.url !== '#' ? (
                          <a 
                            href={item.url} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="btn btn-primary btn-sm"
                          >
                            Открыть источник
                          </a>
                        ) : (
                          <button className="btn btn-secondary btn-sm" disabled>
                            Источник не указан
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="empty-state">
                  <div className="empty-icon">🔍</div>
                  <h3>Материалы не найдены</h3>
                  <p>Попробуйте изменить поисковый запрос или выберите другой раздел</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default KnowledgeBase;
